import React, { useEffect, useState } from 'react'

import { func, string } from 'prop-types'

let AuthModal = null
let signInModalImportPromise = null

export const importAuthModal = () => {
  if (!signInModalImportPromise) {
    signInModalImportPromise = import(
      /* webpackChunkName: "auth-modal" */
      './AuthModal'
    ).then((mod) => { AuthModal = mod.default })
  }
  return signInModalImportPromise
}

function LazyAuthModal({ mode, step = undefined, locale = 'en', onClose }) {
  const [isLoaded, setIsLoaded] = useState(() => !!AuthModal)

  useEffect(() => {
    if (!AuthModal) {
      importAuthModal().then(() => setIsLoaded(true))
    }
  }, [])

  if (!isLoaded || !AuthModal) return null
  return <AuthModal mode={mode} initialStep={step} locale={locale} onClose={onClose} />
}

LazyAuthModal.propTypes = {
  mode: string.isRequired,
  step: string,
  locale: string,
  onClose: func.isRequired,
}

export default LazyAuthModal
